import { Button } from "antd";
import React, { FC, useMemo } from "react";
import { useJCommonContext } from "../JCommonProvider";
import { CMSCTA } from "../models";
import { NavigationType } from "../types/navigationTypes";
import './JCMSCTA.scss';
import htmlParser from "html-react-parser";

export type JCMSCTAProps = CMSCTA & {
    action?: (cta: CMSCTA) => void,
    htmlType?: 'button' | 'reset' | 'submit',
    disabled?: boolean
    style?: React.CSSProperties
}

export const JCMSCTA: FC<JCMSCTAProps> = props => {
    const { navigate, getImageURL } = useJCommonContext();

    const size = useMemo(() => props.size || 'large', [props.size])

    const disabled = useMemo(() => props.disabled, [props.disabled])

    const htmlType = useMemo(() => {
        switch (true) {
            case !!props.htmlType:
                return props.htmlType
            case props.scope === 'SUBMIT':
                return 'submit'
            case props.scope === 'RESET':
                return 'reset'
            default:
                return 'button';
        }
    }, [props.htmlType, props.scope])

    const color = useMemo(() => {
        switch (true) {
            case !!props.color:
                return props.color
            case props.scope === 'SUBMIT':
                return 'primary'
            case props.type === 'WRAPLESS':
            case props.type === 'LINK':
            case props.scope === 'RESET':
            case props.scope === 'BUTTON':
                return 'default'
            default:
                return 'primary';
        }
    }, [props.color, props.type])

    const action = () => {
        if (!['submit', 'reset'].includes(htmlType || '')) {
            if (props?.href?.type === 'EXTERNAL') {
                const anchor = document.createElement('a');
                const name = props.href.value.replace(/^.*[\\\/]/, '')
                const url = props.href.value
                const target = props.href.target
                anchor.setAttribute('href', url);
                if (target) {
                    anchor.setAttribute('target', target);
                }
                anchor.innerHTML = name
                document.body.appendChild(anchor);
                anchor.click();
                if (anchor.parentNode) anchor.parentNode.removeChild(anchor);
            } else if (props.action) {
                props.action(props)
            } else if (props.scope) {
                navigate(props.scope as NavigationType, props.scopeParameters)
            }

        }
    }

    return (
        <span
            className={`jcms-cta jcms-cta-size-${size} ${(props?.image?.src && props?.image?.src !== "") ? 'jcms-cta-img' : ''}`}
        >
            <Button
                style={props?.style}
                disabled={disabled}
                htmlType={htmlType}
                size={size}
                onClick={action}
                className={`jcms-cta-type-${props.type?.toLowerCase()}  jcms-cta-color-${color}`}
                type={'default'}
                shape="round"
            >
                {props?.image?.src && <img className={'btn-img'} src={getImageURL(props?.image?.src)} aria-hidden={true}/>}
                {props.title && htmlParser(props.title)}
                {props.text && htmlParser(props.text)}
            </Button>
        </span>
    )
}